import React from 'react'
import { Navigate } from 'react-router-dom'

export default function Protection({children}) {
    const user = localStorage.getItem("user")
  return (
    user ? children : <Navigate to={"/login"} />
  )
}